import React from "react";
import { useTranslation } from "react-i18next";
import { FormLabelElementWrapper } from "../../../../../projects/EquipmentList/AddEquipment/ModelingEquipment/CarbonWeight/CarbonWeight";
import { Input } from '@photocarbone/nooco-ui';
import { BundleDTO, BundleLineDTO } from "../../../../../models/BundleDTO";


export type RenderModelingPhaseProps = {
  bundleLines: BundleLineDTO[],
  line: BundleDTO,
  handleChangeModelingPhase: Function
};
const RenderModelingPhase = ({bundleLines, line, handleChangeModelingPhase}: RenderModelingPhaseProps) => {
  const { t } = useTranslation();
  if (!bundleLines || bundleLines?.length === 0) return null;

  return (
    <div className="bundle-details-equipments modeling">
      {
        bundleLines?.map((bundleLine) => {

          return (
            <div style={{display: "flex", padding: "2rem", gap: "3rem", flexWrap: "wrap"}} >
              {/* production */}
              <div className="formElementWrapper">
                <FormLabelElementWrapper
                  labelPhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_B2CE1A"
                  labelDefaultValue={`Production(kg eq. CO₂/${line?.unit})`}
                  tooltipTitlePhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_81D113"
                  tooltipTitleDefaultValue={`Production`}
                  tooltipKey="Production"
                  t={t}
                  unit={line?.unit}
                />
                <Input
                  width={'200px'}
                  defaultValue={bundleLine.modelingEquipmentCarbonWeightForm?.product}
                  onChange={(value ) =>{
                    if (!value) return;
                    handleChangeModelingPhase({bundleLine, formName: 'product', value})
                  }}
                />
              </div>
              {/* installation */}
              <div className="formElementWrapper">
                <FormLabelElementWrapper
                  labelPhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_8EDDE4"
                  labelDefaultValue={`Installation(kg eq. CO₂/${line?.unit})`}
                  tooltipTitlePhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_FA72BF"
                  tooltipTitleDefaultValue={`Edification`}
                  tooltipKey="Edification"
                  t={t}
                  unit={line?.unit}
                />
                <Input
                  width={'200px'}
                  defaultValue={bundleLine.modelingEquipmentCarbonWeightForm?.installation}
                  onChange={(value ) =>{
                    if (!value) return;
                    handleChangeModelingPhase({bundleLine, formName: 'installation', value})
                 } }
                />
              </div> 
              {/* usage */}
              <div className="formElementWrapper">
              <FormLabelElementWrapper
                labelPhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_031F63"
                labelDefaultValue={`Utilisation(kg eq. CO₂/${line?.unit})`}
                tooltipTitlePhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_BC490D"
                tooltipTitleDefaultValue={`Exploitation`}
                tooltipKey="Exploitation"
                t={t}
                unit={line?.unit}
              />
                <Input
                  width={'200px'}
                  defaultValue={bundleLine.modelingEquipmentCarbonWeightForm?.usage}
                  onChange={(value ) =>{
                    if (!value) return;
                    handleChangeModelingPhase({bundleLine, formName: 'usage', value})
                  }}
                />
              </div> 
              {/* endOfLife */}
              <div className="formElementWrapper">
                <FormLabelElementWrapper
                  labelPhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_F0DDAF"
                  labelDefaultValue={`Fin de vie(kg eq. CO₂/${line?.unit})`}
                  tooltipTitlePhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_F34F13"
                  tooltipTitleDefaultValue={`Fin de vie`}
                  tooltipKey="Fin de vie"
                  t={t}
                  unit={line?.unit}
                />
                <Input
                  width={'200px'}
                  defaultValue={bundleLine.modelingEquipmentCarbonWeightForm?.endOfLife}
                  onChange={(value ) =>{
                      if (!value) return;
                      handleChangeModelingPhase({bundleLine, formName: 'endOfLife', value})
                  }}
                />
              </div> 
              {/* profit */}
              <div className="formElementWrapper">
                <FormLabelElementWrapper
                  labelPhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_4348D5"
                  labelDefaultValue={`Bénéfices et charges(kg eq. CO₂/${line?.unit})`}
                  tooltipTitlePhraseKey="APP.CARBONWEIGHT.CARBONWEIGHT.PH_8274F1"
                  tooltipTitleDefaultValue={`Module D`}
                  tooltipKey="Module D"
                  t={t}
                  unit={line?.unit}
                />
                <Input
                  width={'200px'}
                  defaultValue={bundleLine.modelingEquipmentCarbonWeightForm?.profit}
                  onChange={(value ) =>{
                    if (!value) return;
                    handleChangeModelingPhase({bundleLine, formName: 'profit', value})
                 } }
                />
              </div>
            </div>
          )
        })
      }
    </div>
  )
}; 

export default RenderModelingPhase;